import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        padding: theme.spacing(3),
        display: 'flex',
        alignItems: 'center',
        minHeight: '100vh',
    },
    card: {
        minWidth: 275,
        height: '300px', // Adjust this value to make the card taller
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
    title: {
        fontSize: 14,
    },
    pos: {
        marginBottom: 12,
    },
}));
/**
 * View: DqProductsDisplay
 *
 * **Data Schema:**
 *
 * data = {
 * }
 *
 * **Actions:**
 * - `navigateToProgramCreator()`:
 * - `navigateToProgramRating()`:
 * - `navigateToDQGuide()`:
 *
 * **Options:**
 *
 * options = {
 * }
 *
 * **Usage Example:**
 * <ProductDisplay data={data} actions={actions} options={options} />
 */

const DqProductsDisplay = ({ actions }) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                    <Card className={classes.card}>
                        <CardContent>
                            <Typography className={classes.title} color="textSecondary" gutterBottom>
                                Program Creator
                            </Typography>
                            <Typography variant="h5" component="h2">
                                Create Programs
                            </Typography>
                            <Typography className={classes.pos} color="textSecondary">
                                Create new programs easily
                            </Typography>
                            <Button variant="contained" color="primary" onClick={actions.navigateToProgramCreator}>
                                Go to Program Creator
                            </Button>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Card className={classes.card}>
                        <CardContent>
                            <Typography className={classes.title} color="textSecondary" gutterBottom>
                                Program Rating
                            </Typography>
                            <Typography variant="h5" component="h2">
                                Rate Programs
                            </Typography>
                            <Typography className={classes.pos} color="textSecondary">
                                Rate existing programs
                            </Typography>
                            <Button variant="contained" color="primary" onClick={actions.navigateToProgramRating}>
                                Go to Program Rating
                            </Button>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <Card className={classes.card}>
                        <CardContent>
                            <Typography className={classes.title} color="textSecondary" gutterBottom>
                                DQ Guide
                            </Typography>
                            <Typography variant="h5" component="h2">
                                View DQ Guide
                            </Typography>
                            <Typography className={classes.pos} color="textSecondary">
                                Learn more about DQ
                            </Typography>
                            <Button variant="contained" color="primary" onClick={actions.navigateToDQGuide}>
                                Go to DQ Guide
                            </Button>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </div>
    );
};

export default DqProductsDisplay;